import Types from "./Types";

const INIT_STATE = {
  brands: [],
  filterBrands: [],
  brand: {},
  count: 0,
  listCount: 0,
  load: null,
  error: null,
};

export function brandsReducer(state = INIT_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.BRANDS_LOADING: {
      return {
        ...state,
        load: payload,
      };
    }
    case Types.GET_BRANDS_SUCCESS: {
      return {
        ...state,
        brands: payload?.data?.brands,
        count: payload?.extra?.total_count,
      };
    }
    case Types.GET_SCROLL_BRANDS_SUCCESS: {
      return {
        ...state,
        filterBrands:
          payload?.extra?.page_number == 1
            ? payload?.data?.brands
            : [...state.filterBrands, ...(payload?.data?.brands || [])],
        listCount: payload?.extra?.total_count,
      };
    }
    case Types.ADD_BRANDS_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.GET_BRANDS_DETAILS_SUCCESS: {
      return {
        ...state,
        brand: payload?.data?.brand,
      };
    }
    case Types.UPDATE_BRANDS_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.DELETE_BRANDS_SUCCESS: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
}
